'use strict';

import $ from 'jquery';
import 'moment';
import 'daterangepicker';
import { recaptchaUpdater } from './recaptcha';
import croppie from 'croppie';

Dropzone.autoDiscover = false;
import 'dropzone';

const challengesForm = {
  settings: {
    _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
  },

  crop() {
    let crop;
    const $uploadCrop = document.getElementById('upload-crop');
    const $modalCrop = document.getElementById('modal-crop');
    const $inputImg = document.querySelector('.js-challenge-cover');

    $inputImg.addEventListener('change', function () {
      var reader = new FileReader();
      reader.onload = function (e) {
        crop = new croppie($uploadCrop, {
          enableExif: true,
          viewport: {
            width: 256,
            height: 170,
          },
          boundary: {
            width: 300,
            height: 200,
          },
        });

        crop
          .bind({
            url: e.target.result,
          })
          .then(function () {
            $modalCrop.classList.add('is-active');
          });
      };
      reader.readAsDataURL(this.files[0]);
    });

    $('.js-crop-challenge').on('click', function (e) {
      e.preventDefault();

      crop
        .result({
          type: 'canvas',
          size: { width: 512, height: 340 },
          format: 'jpeg',
          quality: 0.6,
        })
        .then(function (resp) {
          $('#cover_chosen').attr('src', resp);
          $('[name="cover"]').val(resp);
          $('#modal-crop').removeClass('is-active');
          setTimeout(() => {
            crop.destroy();
          }, 300);
        });
    });

    $('.js-crop-cancel').on('click', function () {
      document.getElementById('modal-crop').classList.remove('is-active');

      setTimeout(() => {
        crop.destroy();
      }, 300);
    });
  },

  dropzone() {
    new Dropzone('#myDropzone', {
      url: `${window.location.origin}/acoes-disponiveis/materiais/upload-arquivos`,
      paramName: 'gallery',
      maxFilesize: 10,
      maxFiles: 50,
      params: {
        _token: s._token,
        challenge_id: $('[name="id"]').val(),
      },
      previewTemplate: document.querySelector('#tpl').innerHTML,
      addRemoveLinks: true,
      dictDefaultMessage: 'Selecione os arquivos que deseja enviar',
      dictCancelUpload: 'Cancelar o envio',
      dictRemoveFile: 'Remover',
      dictMaxFilesExceeded: 'Você já adicionou um arquivo',
      dictFileTooBig: 'Arquivo muito grande',
      dictInvalidFileType: 'Este arquivo não é uma imagem',
      init: function () {
        this.on('success', function (file, response) {
          $('.added_photos').append(
            '<input type="hidden" data-name="' + file.name + '" name="gallery[]" value="' + response + '"/>'
          );

          let $item = $('<input type="hidden" data-name="' + file.name + '" name="material_name[]"/>');
          $('.added_photos').append($item);

          $(file.previewElement.querySelector('[data-item-name]')).on('keyup', function (e) {
            $item[0].value = e.target.value;
          });
        });
        this.on('removedfile', function (file, response) {
          $("input[name='gallery[]'], input[name='material_name[]']").each(function () {
            if ($(this).attr('data-name') == file.name) {
              $(this).remove();
            }
          });
        });
      },
    });
  },

  dateRange() {
    var prev_date = new Date();

    $('.js-date').daterangepicker({
      autoUpdateInput: false,
      locale: {
        format: 'DD/MM/YYYY',
        cancelLabel: 'Limpar',
        applyLabel: 'Aplicar',
        customRangeLabel: 'Custom',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: [
          'Janeiro',
          'Fevereiro',
          'Março',
          'Abril',
          'Maio',
          'Junho',
          'Julho',
          'Agosto',
          'Setembro',
          'Outubro',
          'Novembro',
          'Dezembro',
        ],
      },
    });

    $('.js-date').on('apply.daterangepicker', function (ev, picker) {
      $('input[name="start_at"]').val(picker.startDate.format('DD/MM/YYYY'));
      $('input[name="end_at"]').val(picker.endDate.format('DD/MM/YYYY'));
      $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
    });
  },

  geoAutocomplete() {
    let interval = setInterval(() => {
      if (typeof google === 'object' && typeof google.maps === 'object') {
        initAutocomplete();
      }
    }, 200);

    let placeSearch, autocomplete;
    let componentForm = {
      administrative_area_level_1: 'short_name',
      administrative_area_level_2: 'short_name',
    };

    function initAutocomplete() {
      clearInterval(interval);
      // Create the autocomplete object, restricting the search to geographical
      // location types.
      autocomplete = new google.maps.places.Autocomplete(
        /** @type {!HTMLInputElement} */ (document.getElementById('autocomplete')),
        { types: ['geocode'] }
      );

      // When the user selects an address from the dropdown, populate the address
      // fields in the form.
      autocomplete.addListener('place_changed', fillInAddress);
    }

    function fillInAddress() {
      // Get the place details from the autocomplete object.
      var place = autocomplete.getPlace();

      for (var component in componentForm) {
        document.getElementById(component).value = '';
        document.getElementById(component).disabled = false;
      }

      // Get each component of the address from the place details
      // and fill the corresponding field on the form.
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
          var val = place.address_components[i][componentForm[addressType]];
          document.getElementById(addressType).value = val;
        }
      }
    }

    $('[data-geolocate]').on('focus', geolocate());

    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    function geolocate() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy,
          });
          autocomplete.setBounds(circle.getBounds());
        });
      }
    }
  },

  addRemoveOrganizations() {
    $(document).on('click', '.js-add-organization', function (e) {
      e.preventDefault();

      let num = parseInt($(this).attr('data-count')) + 1;

      let template = `
          <div class="o-card u-m-t-30" id="organization-id-${num}">
            <label class="u-m-t-15">Nome da organização*</label>
            <input type="text" class="form-control" name="multi_organization_name[${num}]" placeholder="Nome da organização" maxlength="80">
            
            <label class="u-m-t-15">CNPJ*</label>
            <input type="text" class="form-control js-form-cnpj" name="multi_organization_cnpj[${num}]" placeholder="CNPJ da organização" maxlength="20" >

            <div class="o-card--button">
              <button class="o-btn o-btn--secondary js-drop-organization u-m-t-15" data-id="organization-id-${num}"><i class="fa fa-trash"></i> Remover</button>
            </div>
          </div>`;

      $('.s-challenges--create-grid').append(template);

      $('.js-form-cnpj').mask('00.000.000/0000-00');

      $(this).attr('data-count', num);
    });

    $(document).on('click', '.js-drop-organization', function (e) {
      e.preventDefault();
      $('#' + $(this).attr('data-id')).remove();
    });
  },

  bindActions() {
    const $groupsContainer = $('[data-groups]');
    const $selectGroups = $('.js-groups');

    $('[name="has_groups"]').on('change', function () {
      if ($(this).val() == 1) {
        $groupsContainer.css({ display: 'block' });
      } else {
        $groupsContainer.css({ display: 'none' });
        $selectGroups.val('').trigger('change');
      }
    });
  },

  init() {
    recaptchaUpdater('challenge');
    _this.dropzone();
    _this.dateRange();
    _this.geoAutocomplete();
    _this.crop();
    _this.addRemoveOrganizations();
    _this.bindActions();
  },
};

const s = challengesForm.settings,
  _this = challengesForm;

export default _this;
